import { FaultCode } from '../enum/fault-code'
import { rememberPayload, wireEntity } from '../../_utils/fcdc-v2'

export class Fault {
  code: FaultCode
  text?: string
  set?: Fault[]
  aligns?: boolean
  file?: string
  line?: number
  existingId?: string

  constructor(json: any) {
    this.code = json.code as FaultCode
    this.text = json.text
    this.aligns = json.aligns
    this.file = json.file
    this.line = json.line
    this.existingId = json.existingId

    if (json.code == FaultCode.Set && json.set) {
      const set: Fault[] = json.set.map((item: any) => new Fault(item))
      if (set.length == 1) {
        this.code = set[0].code
        this.text = set[0].text
        this.aligns = set[0].aligns
        this.file = set[0].file
        this.line = set[0].line
        this.existingId = set[0].existingId
        this.set = undefined
        rememberPayload(this, {
          ...json,
          ...(wireEntity(set[0]) as Record<string, unknown>),
        })
        return
      }
      this.set = set
    } else {
      this.set = undefined
    }

    rememberPayload(this, json)
  }
}
